export const AdmissionSubjectTypeEnum = {
  COMPULSORY_SUBJECTS_FOR_OBTAINING_CERTIFICATE_9_11: 1, // Обязательные предметы для получения аттестата 9(10) классов
  COMPULSORY_SUBJECTS_FOR_OBTAINING_CERTIFICATE_11_12: 2, // Обязательные предметы для получения аттестата 11(12) классов
  COMPULSORY_SUBJECTS_FOR_ADMISSION_COLLEGE_9_10: 3, // Обязательные предметы для поступления в колледж после 9(10) классов
  COMPULSORY_SUBJECTS_FOR_ADMISSION_COLLEGE_11_12: 4, // Обязательные предметы для поступления в колледж после 11(12) классов
  PROFILE_SUBJECTS_FOR_ADMISSION_COLLEGE_9_10: 5, // Профильные предметы для поступления в колледж после 9(10) классов
  PROFILE_SUBJECTS_FOR_ADMISSION_COLLEGE_11_12: 6, // Профильные предметы для поступления в колледж после 11(12) классов
  COMPULSORY_SUBJECTS_SCHOOL: 7, // Обязательный (школа)
  PROFILE_SUBJECTS_SCHOOL: 8, // Профильный (школа)
  PROFILE_SUBJECTS_FOR_OBTAINING_CERTIFICATE_9_10: 9,
  PROFILE_SUBJECTS_FOR_OBTAINING_CERTIFICATE_11_12: 10,

  getSubjectType(type, educatedID) {
    let subjectTypeID;
    if (type === 'admissionSubject' || type === 'mandatory_subjects') {
      subjectTypeID = educatedID === 1 ? this.COMPULSORY_SUBJECTS_FOR_ADMISSION_COLLEGE_9_10 : this.COMPULSORY_SUBJECTS_FOR_ADMISSION_COLLEGE_11_12;
    } else if (type === 'profileSubject' || type === 'profile_subjects') {
      subjectTypeID = educatedID === 1 ? this.PROFILE_SUBJECTS_FOR_ADMISSION_COLLEGE_9_10 : this.PROFILE_SUBJECTS_FOR_ADMISSION_COLLEGE_11_12;
    } else if (type === 'profileSubjectForCertificate') {
      subjectTypeID = educatedID === 1 ? this.PROFILE_SUBJECTS_FOR_OBTAINING_CERTIFICATE_9_10 : this.PROFILE_SUBJECTS_FOR_OBTAINING_CERTIFICATE_11_12;
    } else if (type === 'admissionSubjectForEnt') {
      subjectTypeID = educatedID === 2 ? this.COMPULSORY_SUBJECTS_SCHOOL : null; // 11-12
    } else if (type === 'profileSubjectForEnt') {
      subjectTypeID = educatedID === 2 ? this.PROFILE_SUBJECTS_SCHOOL : null; // 11-12
    }

    return subjectTypeID;
  }

};



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/dictionary/subject-for-admission-list/admission-subject-type.enum.ts